// extracted by mini-css-extract-plugin
module.exports = {"faq":"Faq_faq__iFuC2","faq__title":"Faq_faq__title__SepHQ","faq__grid":"Faq_faq__grid__l5ZXx","faq__column":"Faq_faq__column__tSB79","faq__item":"Faq_faq__item__8t0AI"};